import { GlobalAxios } from "../axios/axios-config";
import {
  IMarComAutomationClassifications,
  INewMarComAutomationClassifications,
} from "../models/mar-com-automation-classifications";

const CAMPAIGN_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/MarComAutomationClassification";

export const createMarComAutomationClassification = (
  params: INewMarComAutomationClassifications
) => {
  return GlobalAxios.post(CAMPAIGN_ROUTE, params);
};

export const getMarComAutomationClassificationById = (id: string) => {
  return GlobalAxios.get<IMarComAutomationClassifications>(
    CAMPAIGN_ROUTE + "/" + id
  );
};

export const updateMarComAutomationClassification = ({
  id,
  item,
}: {
  id: string;
  item: INewMarComAutomationClassifications;
}) => {
  return GlobalAxios.put(CAMPAIGN_ROUTE + "/" + id, item);
};
